export default "__VITE_ASSET__BqNvlBW3__"